module.exports = __webpack_public_path__ + "img/invoice.71666d1b.svg";